{
  "column": {
    "name": "Name",
    "type": "Type",
    "subscribedServices": "Subscribed services",
    "expirationDate": "Expiration date",
    "expirationDateFormat": "YYYY/MM/DD [at] hh:mm A"
  },
  "addSingleCertificate": "Add a certificate",
  "addCertificate": "Add certificate",
  "updateCertificate": "Update certificate",
  "certificate": {
    "typeTitle": "Type of certificate",
    "deviceTrustchain": "Device Trustchain",
    "pkiRootCa": "MS PKI root CA",
    "ldapsRootCa": "LDAPS root CA"
  },
  "caRestrictionInformation": "The submitted certificate must be a .PEM file and must be less than 1MB in size.",
  "dropCertificate": "Deposit the certificate here or click here to start the selection",
  "noCertificate": "No certificates are registered in the Truststore",
  "validation": {
    "rootCa": "Certificate is mandatory and must me a .PEM file",
    "certType": "Certificate type is mandatory"
  }
}
